import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EditableDataGrid } from '../../../builderPackage/components/editableDataGrid/editableDataGrid';
import { MuiStack } from '../../../components';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { useAppSelector } from '../../../store/hooks';
import { getLocalStorageItem } from '../../../utils/storageHelper';
// import { getLocationDetailsAPICall, getSerialNoDetails } from '../services/apiCalls'
// import IssueQuantityCell from './issueQuantityCell'
// import LocationDetailCell from './locationDetailcell'
// import { LocationMultiSelectPopUp } from './locationMultiSelectPopup'
// import { MultiSelectPopUp } from './multiSelectPopUp'
import { rowdata } from '../services/jciReturnEnitiy';
var JCIReturnPartDetails = function (props) {
    var onChange = props.onChange, value = props.value, _a = props.name, name = _a === void 0 ? 'partsDetailsList' : _a;
    var _b = useState(false), isSearchBoxVisible = _b[0], setIsSearchBoxVisible = _b[1];
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var _d = useState(false), isSingleSelection = _d[0], setIsSingleSelection = _d[1];
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _e = useState(), modalProps = _e[0], setModalProps = _e[1];
    var _f = useState(), locationModalProps = _f[0], setLocationModalProps = _f[1];
    var _g = useState([]), matchedIds = _g[0], setMatchedIds = _g[1];
    var _h = useState(), issueQty = _h[0], setIssueQty = _h[1];
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var columns = [{
            field: 'ProductName',
            headerName: 'Part name & code',
            editable: true,
            flex: 1,
            width: 300,
            align: 'left',
            headerAlign: 'left',
            renderCell: function (params) {
                var _params$row, _params$row2;
                console.log("params.hasFocus", params.hasFocus);
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '100%'
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    flexDirection: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h5",
                    style: {
                        fontSize: 'sm',
                        fontWeight: "normal",
                        color: 'secondary.900'
                    }
                }, params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.ProductName), /*#__PURE__*/ React.createElement(Typography, {
                    style: {
                        fontSize: 'sm',
                        fontWeight: "normal",
                        color: 'secondary.600'
                    }
                }, params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Code)), /*#__PURE__*/ React.createElement(MuiStack, null));
            }
        }, {
            type: 'singleSelect',
            field: 'UnitOfMeasurementName',
            headerName: 'UOM',
            editable: false,
            flex: 1,
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Rate',
            headerName: 'Rate(₹)',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'ServiceType',
            headerName: 'Service Type',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'InvoicedQty',
            headerName: 'Invoiced qty',
            editable: true,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Returnquantity',
            headerName: 'Returnquantity',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }, {
            field: 'Returntax ',
            headerName: 'Return tax',
            editable: false,
            flex: 1,
            type: 'number',
            align: 'left',
            headerAlign: 'left'
        }];
    var locationColumns = [{
            field: 'LocationName',
            headerName: 'Location Name',
            editable: false,
            flex: 1
        }, {
            field: 'QuantityAvailable',
            headerName: 'Available Qty.',
            editable: false,
            flex: 1
        }, {
            field: 'IssueQuantity',
            headerName: 'Issue Qty',
            editable: true,
            flex: 1,
            renderCell: function (params) {
                var _params$row4;
                if ((params === null || params === void 0 ? void 0 : params.value) > 0) {
                    var _value$name;
                    setIssueQty(params === null || params === void 0 ? void 0 : params.value);
                    (_value$name = value[name]) === null || _value$name === void 0 || _value$name.map(function (r) {
                        var _params$row3;
                        return (params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.id) === (r === null || r === void 0 ? void 0 : r.id) ? _objectSpread(_objectSpread({}, r), {}, {
                            IssueQuantity: issueQty
                        }) : r;
                    });
                }
                return /*#__PURE__*/ React.createElement(Typography, null, params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.IssueQuantity);
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: rowdata,
        onChange: onChange,
        dataGridHeader: 'Part details',
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            disableColumnSorting: true,
            disableColumnMenu: false,
            onCellKeyDown: function (params, e) {
                if (e.key === 'Enter')
                    e.preventDefault();
            },
            sx: {
                borderRadius: '12px !important'
            },
            initialState: {
                aggregation: {
                    model: {
                        InvoicedQty: 'sum',
                        Qty: 'sum'
                    }
                }
            }
        }
    })));
};
export default JCIReturnPartDetails;
